interface SectionLoaderProps {
  label: string;
  minHeight?: number;
}

/** Branded stand-in for the plain-text "Loading..." fallback used while a section's own data is in flight. */
export default function SectionLoader({ label, minHeight = 160 }: SectionLoaderProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 10, minHeight, padding: 24 }}>
      <div style={{ width: 22, height: 22, borderRadius: '50%', border: '2.5px solid #dbeafe', borderTopColor: '#2563eb', animation: 'spin 0.7s linear infinite' }} />
      <div style={{ color: '#64748b', fontSize: '0.8125rem' }}>{label}</div>
    </div>
  );
}
